export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const HOME_SCREEN = 'HOME_SCREEN'
export const TEAM_SCREEN = "TEAM_SCREEN"
export const MAINTINANCE_STATUS = "MAINTINANCE_STATUS"
export const SET_TERM = "SET_TERM"
export const TERM_SCREEN="TERM_SCREEN"